import { render, staticRenderFns } from "./modalRegisterProduct.vue?vue&type=template&id=6359a237"
import script from "./modalRegisterProduct.vue?vue&type=script&lang=js"
export * from "./modalRegisterProduct.vue?vue&type=script&lang=js"
import style0 from "./modalRegisterProduct.vue?vue&type=style&index=0&id=6359a237&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6359a237')) {
      api.createRecord('6359a237', component.options)
    } else {
      api.reload('6359a237', component.options)
    }
    module.hot.accept("./modalRegisterProduct.vue?vue&type=template&id=6359a237", function () {
      api.rerender('6359a237', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/stock/components/modalRegisterProduct.vue"
export default component.exports